const Square = ({ fillColor }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_350_2583" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66667 4H18.3333C19.7206 4 20.5 4.77941 20.5 6.16667V17.8333C20.5 19.2206 19.7206 20 18.3333 20H6.66667C5.27941 20 4.5 19.2206 4.5 17.8333V6.16667C4.5 4.77941 5.27941 4 6.66667 4Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66667 4H18.3333C19.7206 4 20.5 4.77941 20.5 6.16667V17.8333C20.5 19.2206 19.7206 20 18.3333 20H6.66667C5.27941 20 4.5 19.2206 4.5 17.8333V6.16667C4.5 4.77941 5.27941 4 6.66667 4Z"
      fill={fillColor}
    />
    <path
      d="M6.66667 5H18.3333V3H6.66667V5ZM18.3333 5C18.8432 5 19.0997 5.14015 19.2298 5.27022C19.3598 5.40029 19.5 5.65681 19.5 6.16667H21.5C21.5 5.28927 21.2504 4.46246 20.644 3.85601C20.0375 3.24955 19.2107 3 18.3333 3V5ZM19.5 6.16667V17.8333H21.5V6.16667H19.5ZM19.5 17.8333C19.5 18.3432 19.3598 18.5997 19.2298 18.7298C19.0997 18.8598 18.8432 19 18.3333 19V21C19.2107 21 20.0375 20.7504 20.644 20.144C21.2504 19.5375 21.5 18.7107 21.5 17.8333H19.5ZM18.3333 19H6.66667V21H18.3333V19ZM6.66667 19C6.15681 19 5.90029 18.8598 5.77022 18.7298C5.64015 18.5997 5.5 18.3432 5.5 17.8333H3.5C3.5 18.7107 3.74955 19.5375 4.35601 20.144C4.96246 20.7504 5.78927 21 6.66667 21V19ZM5.5 17.8333V6.16667H3.5V17.8333H5.5ZM5.5 6.16667C5.5 5.65681 5.64015 5.40029 5.77022 5.27022C5.90029 5.14015 6.15681 5 6.66667 5V3C5.78927 3 4.96246 3.24955 4.35601 3.85601C3.74955 4.46246 3.5 5.28927 3.5 6.16667H5.5Z"
      fill={fillColor}
      mask="url(#path-1-inside-1_350_2583)"
    />
  </svg>
);

Square.propTypes = {
  fillColor: PropTypes.string,
};

export default Square;
